import React from "react";
import { twMerge } from "tailwind-merge";
import { ReactComponent as CheckSmallIcon } from "@assets/icons/checked_small.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { Box } from "@mantine/core";

type BarStepsProgressVerticalProps = {
  activeStep?: number;
};

const BarStepsProgressVertical: React.FC<BarStepsProgressVerticalProps> = ({
  activeStep = 1,
}) => {
  const steps = [
    {
      label: "Eligibility Questions",
      sublabel: "3 simple questions to check you're eligible.",
    },
    {
      label: "The Fact Find",
      sublabel:
        "Tell us a bit about yourself, so Penny can create your personalised pension recommendation.",
    },
    {
      label: "The Recommendation",
      sublabel:
        "Your personalised pension recommendation will be ready in 24 hours.",
    },
    {
      label: "The Advice",
      sublabel:
        "You don't have to figure it out alone. Speak with your Penny advisor to understand your options. In your time, on your terms.",
    },
    {
      label: "Apply",
      sublabel:
        "Complete your approved pension application and we'll have you up and running in minutes.",
    },
  ];

  return (
    <div className="flex flex-col gap-y-2">
      {steps.map((item, index) => (
        <Box
          sx={{
            ":not(:last-of-type)": {
              "&>div": {
                position: "relative",

                ":after": {
                  content: "''",
                  border:
                    index === 0 ? "1px dashed #E7E5E4" : "1px solid #E7E5E4",
                  position: "absolute",
                  top: "calc(100% + 8px)",
                  left: "50%",
                  transform: "translateX(-50%)",
                  height: "calc(100% * 2)",
                  zIndex: 10,
                },
              },
            },
          }}
          className="flex items-start gap-x-2 h-full overflow-hidden"
        >
          <div
            className={twMerge(
              activeStep === index + 1
                ? "bg-[#F4E34E]"
                : activeStep > index + 1
                ? "bg-pn_green-500"
                : "bg-pn_gray-200",
              "w-6 h-6 rounded-full flex items-center justify-center"
            )}
          >
            <span className="text-pn-button-2 text-pn_gray-950">
              {activeStep > index + 1 && activeStep !== index + 1 ? (
                <CheckSmallIcon />
              ) : index === 0 ? (
                <PennyIcon className="w-[12px] h-[12px]" />
              ) : (
                index
              )}
            </span>
          </div>
          <div className="flex-1 flex flex-col py-[3px] gap-y-1">
            <span className="text-pn-callout-emphasis text-pn_gray-950">
              {item.label}
            </span>
            <span className="text-pn-callout-regular text-pn_gray-600">
              {item.sublabel}
            </span>
          </div>
        </Box>
      ))}
    </div>
  );
};
export default BarStepsProgressVertical;
